"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = require("react");

var _Group = _interopRequireDefault(require("ol/layer/Group"));

var _NewLayerForm = _interopRequireDefault(require("../NewLayerForm/NewLayerForm"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultLayerOpts = {
  opacity: 1,
  maxResolution: Infinity,
  maxZoom: Infinity,
  minResolution: 0,
  minZoom: -Infinity,
  visible: true,
  zIndex: 0,
  name: 'unnamed group layer'
};

var NewGroupLayerForm = function NewGroupLayerForm(_ref) {
  var map = _ref.map,
      _ref$parentLayerGroup = _ref.parentLayerGroup,
      parentLayerGroup = _ref$parentLayerGroup === void 0 ? undefined : _ref$parentLayerGroup,
      _ref$layerOpts = _ref.layerOpts,
      layerOpts = _ref$layerOpts === void 0 ? defaultLayerOpts : _ref$layerOpts,
      _ref$onFinish = _ref.onFinish,
      onFinish = _ref$onFinish === void 0 ? undefined : _ref$onFinish;
  var onInternalFinish = (0, _react.useCallback)(function (values) {
    //create new Group Layer with values from Form
    var layer = new _Group.default(values); //add layer to the map

    if (parentLayerGroup) parentLayerGroup.getLayers().push(layer);else map.addLayer(layer); //execute onFinish

    onFinish && onFinish();
  }, [map, parentLayerGroup, onFinish]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewLayerForm.default, {
    layerOpts: layerOpts,
    onFinish: onInternalFinish
  });
};

var _default = NewGroupLayerForm;
exports.default = _default;